/* eslint-disable import/no-anonymous-default-export */
import TrafficConstants from './TrafficConsts'

const initialState = {
    status: '',
    usage: null,
    capacity: null,
    rawTraffic: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case TrafficConstants.RAW_TRAFFIC_SUCCESS: {
            return {
                ...state,
                status: 'success',
                rawTraffic: action.payload.data,
            };
        }
        case TrafficConstants.RAW_TRAFFIC_FAILURE: {
            return {
                ...state,
                status: 'failure',
                rawTraffic: null,
            };
        }
        case TrafficConstants.RAW_CAPACITY_SUCCESS: {
            return {
                ...state,
                status: 'success',
                capacity: action.payload.data,
            };
        }
        case TrafficConstants.RAW_CAPACITY_FAILURE: {
            return {
                ...state,
                status: 'failure',
                capacity: null,
            };
        }
        case TrafficConstants.RAW_USAGE_SUCCESS: {
            return {
                ...state,
                status: 'success',
                usage: action.payload.data,
            };
        }

        case TrafficConstants.RAW_USAGE_FAILURE: {
            return {
                ...state,
                status: 'failure',
                usage: null,
            };
        }


        default:
            return state
    }
}